import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Badge as BootstrapBadge } from 'react-bootstrap'
import './Badge.module.scss'

const propTypes = {
  /**
   * Appearance of the Badge (Bootstrap 5 / react-bootstrap 2 uses `bg` on the underlying Badge)
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'light']),
  /**
   * Badge content
   */
  children: PropTypes.node,
  /**
   * Class to modify default styles
   */
  className: PropTypes.string,
}

/**
 * Badge — wraps react-bootstrap `Badge` with shared Augmentt styles (`bg` + `badge-*` classes).
 */
function Badge(props) {
  const { children = null, variant = 'primary', className = '', ...rest } = props ?? {}

  return (
    <BootstrapBadge bg={variant} className={clsx('Uic-Badge-base', `badge-${variant}`, className)} {...rest}>
      {children}
    </BootstrapBadge>
  )
}

Badge.propTypes = propTypes

export default Badge
